import type { AssetType } from './types';

/** สกุลเงินฐานของทั้งระบบ (spec Section 4.2) */
export const BASE_CURRENCY = 'THB';

/** อายุ cache ราคาก่อนถือว่าควรดึงใหม่ (spec Section 6.1) */
export const PRICE_TTL_MS: Readonly<Record<AssetType, number>> = {
  stock: 15 * 60_000,
  etf: 15 * 60_000,
  crypto: 2 * 60_000,
  // เงินสดไม่มีวันเก่า ราคาถูกสร้างสด ๆ ทุกครั้งที่ตีมูลค่า ค่านี้จึงไม่ถูกใช้จริง
  cash: 15 * 60_000,
};

/** อายุ cache อัตราแลกเปลี่ยน (spec Section 6.1) */
export const FX_TTL_MS = 60 * 60_000;

/**
 * ราคาเก่ากว่า TTL × ตัวคูณนี้ → ขึ้น badge "ราคา ณ ..." บน UI (spec Section 9.3)
 * แยกจาก TTL เพราะ "ควรดึงใหม่" กับ "เก่าจนต้องเตือน user" คนละเรื่องกัน
 */
export const STALE_MULTIPLIER = 2;

/** ทศนิยมที่ใช้ตอนแสดงผล (spec Section 5.1) */
export const MONEY_DP = 2;
export const PERCENT_DP = 2;

/** ทศนิยมสูงสุดที่ยอมรับสำหรับ quantity (spec Section 5.1) */
export const MAX_QUANTITY_DP: Readonly<Record<AssetType, number>> = {
  stock: 8,
  etf: 8,
  crypto: 18,
  // เงินสดละเอียดสุดแค่หน่วยย่อยของสกุลเงิน
  cash: 2,
};
